import { makeStyles } from '@material-ui/core/styles'
import { BANNER_VARIANTS } from '@v4/components/sections/Banner/Banner.const'

const useStyles = makeStyles(
	() => ({
		root: {
			display: 'flex',
			alignItems: 'center',
		},
		[BANNER_VARIANTS.VARIANT_23]: {
			height: '100%',
			'& $content': {
				height: '100%',
			},
		},
		content: {},
	}),
	{ name: 'Banners' },
)

export default useStyles
